/**
 * Closes an empty section of an organization page (/bank/nbkr/deposits) from indexing.
 *
 * The organization API returns the number of items of every section (`deposits_count`,
 * `news_count`...), absent or 0 when there are none. Such a section is an empty page:
 * the tabs already hide it and the backend sitemap leaves it out.
 */
export const useEmptySectionNoindex = <T extends object>(
  organization: MaybeRefOrGetter<T | undefined>,
  countKey: string
) => {
  useHead(() => {
    const item = toValue(organization)

    if (!item || Number(Reflect.get(item, countKey) ?? 0) > 0) {
      return {}
    }

    return { meta: [{ name: 'robots', content: 'noindex, follow' }] }
  })
}
